import { jsx, jsxs } from "react/jsx-runtime";
import { Box, TextButton, IconChevronLeftOutline } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { B2B_USER_NAV_BORDER_WIDTH_PX, B2B_USER_NAV_PADDING_VERTICAL_PX } from "../../constants/stickyNav.esm.js";
import { useCurrentUser } from "../../hooks/user.esm.js";
import { GROUP_WIDTH_MAP } from "../../mixins/components/GroupMixin.esm.js";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BUserNav.utils.esm.js";
import SignIn from "./SignIn.esm.js";
const B2BUserNav = (props) => {
  const {
    env,
    redirectParam,
    router,
    signInLink,
    transparent,
    userMenuItems
  } = props;
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const {
    data: {
      user
    }
  } = useCurrentUser();
  return /* @__PURE__ */ jsx(Box, { "data-testid": "b2b-user-nav", role: "navigation", "aria-label": "B2B User Navigation", sx: {
    position: "relative",
    borderBottom: `${B2B_USER_NAV_BORDER_WIDTH_PX}px solid $colors.borderLight`,
    background: transparent ? "rgba(0, 0, 0, 0)" : "$colors.backgroundWhite",
    "@media $lg_lte": {
      position: "relative",
      height: "auto",
      width: "100%"
    }
  }, children: /* @__PURE__ */ jsxs(Box, { sx: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: GROUP_WIDTH_MAP.xl,
    margin: "0 auto",
    padding: `${B2B_USER_NAV_PADDING_VERTICAL_PX}px $spacing.sm`
  }, children: [
    /* @__PURE__ */ jsx(Box, { sx: {
      display: "flex",
      alignItems: "center",
      gap: "$spacing.xs"
    }, children: /* @__PURE__ */ jsx(TextButton, { buttonType: "tertiary", inverse: transparent, as: "a", href: "/", fontType: "bodySmall", icon: /* @__PURE__ */ jsx(IconChevronLeftOutline, {}), iconSize: "xs", onClick: yieldCallback(() => {
      sendEvent("cms_anchor", "Zillow Home", "https://www.zillow.com/", cmsInfo);
    }), children: "Zillow Home" }) }),
    signInLink && /* @__PURE__ */ jsx(SignIn, { user, inverse: transparent, signInLink, redirectParam, router, env, userMenuItems })
  ] }) });
};
export {
  B2BUserNav as default
};
